<template>
  <div class="app-wrapper">
    <Nav></Nav>
    <div > <router-view></router-view></div>
    <Footer></Footer>
  </div>
</template>
<script>
  import { Nav,Footer} from './index'
  export default {
    name: 'layout',
    components: {
      Nav,
      Footer,
    }
  }

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .top {
    width: 100%;
    height: 34px;
    background-color: #47acec;
    .innertop {
      width: 1024px;
      height: 34px;
      margin: 0 auto;
      color: #FFF;
      line-height: 34px;
      font-size: 14px;
      .topleft {
        float: left;
      }
    }

  }
 
</style>


// WEBPACK FOOTER //
// src/views/layout/index.vue